export default {
    TWITTER_LINK: "https://google.com/",
    FACEBOOK_LINK: "https://www.facebook.com/",
    TELEGRAM_LINK: "https://www.telegram.com/",
    LINKEDIN_LINK: "https://www.linkedin.com/",
    BLOG_LINK:"https://www.blog.com/",
    YOUTUBE_LINK:"https://www.youtube.com/"
}